<template>
  <v-text-field v-model="formatted" prefix="R$" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { currency } from '@/helpers/formatters/currency'

const model = defineModel<number>({ required: true })

const formatted = computed({
  get: () => currency(model.value / 100).slice(3),
  set: (value) => {
    const v = value.replace(/[^0-9.]/g, '')
    model.value = Math.max(0, Number(v))
  },
})

</script>
